// gavion.email.delivery.* — delivery report of a sequence, timeline delivery badges and the lead's
// suppression chip (Outlook parity with SES; FR/EN parity is tested globally).
export const deliveryMessages = {
  fr: {
    title: "Livraison",
    stats: {
      enrolled: "Inscrits",
      sent: "Envoyés",
      delivered: "Livrés",
      delivered_probable: "Livrés (probable)",
      bounced: "Rebonds",
      complained: "Plaintes",
      unsubscribed: "Désabonnés",
      failed: "Échecs",
    },
    inferred_note:
      "« Livrés (probable) » : courriels Outlook sans avis de non-remise 24 h après l'envoi (déduit, Outlook ne confirme pas la livraison). Rebonds Outlook : avis de non-remise reçus dans la boîte du représentant.",
    badges: {
      bounced: "Rebond",
      complained: "Plainte",
      delivered: "Livré",
      delivered_probable: "Livré (probable)",
      unsubscribed: "Désabonné",
    },
    stop_requests: {
      title: "Demandes d'arrêt à confirmer",
      nav: "Demandes d'arrêt",
      intro:
        "Réponses de compagnies qui semblent demander de ne plus recevoir de courriels, sans certitude. La LCAP exige d'honorer un retrait de consentement dans les 10 jours ouvrables.",
      confirm: "Confirmer le désabonnement",
      ignore: "Ignorer",
      confirmed: "Désabonnement confirmé.",
      ignored: "Demande ignorée.",
      received: "Reçue le %{date}",
      deadline: "Échéance LCAP : %{date}",
      overdue: "Plus de 5 jours ouvrables",
      empty: "Aucune demande en attente.",
      reply: "Réponse : %{subject}",
      lead: "Voir la compagnie",
    },
    suppression: {
      unsubscribe: "Désabonné",
      bounce: "Adresse en rebond",
      complaint: "Plainte (pourriel)",
      other: "Envois bloqués",
      reply: "par réponse",
    },
  },
  en: {
    title: "Delivery",
    stats: {
      enrolled: "Enrolled",
      sent: "Sent",
      delivered: "Delivered",
      delivered_probable: "Delivered (probable)",
      bounced: "Bounces",
      complained: "Complaints",
      unsubscribed: "Unsubscribed",
      failed: "Failures",
    },
    inferred_note:
      "“Delivered (probable)”: Outlook emails with no non-delivery report 24 h after sending (inferred; Outlook does not confirm delivery). Outlook bounces: non-delivery reports received in the rep's mailbox.",
    badges: {
      bounced: "Bounced",
      complained: "Complaint",
      delivered: "Delivered",
      delivered_probable: "Delivered (probable)",
      unsubscribed: "Unsubscribed",
    },
    stop_requests: {
      title: "Stop requests to confirm",
      nav: "Stop requests",
      intro:
        "Lead replies that seem to ask to stop receiving emails, without certainty. CASL requires honouring a withdrawal of consent within 10 business days.",
      confirm: "Confirm unsubscribe",
      ignore: "Ignore",
      confirmed: "Unsubscribe confirmed.",
      ignored: "Request ignored.",
      received: "Received %{date}",
      deadline: "CASL deadline: %{date}",
      overdue: "Over 5 business days",
      empty: "No pending request.",
      reply: "Reply: %{subject}",
      lead: "Open the lead",
    },
    suppression: {
      unsubscribe: "Unsubscribed",
      bounce: "Bouncing address",
      complaint: "Complaint (spam)",
      other: "Sending blocked",
      reply: "by reply",
    },
  },
};
